import React, { useMemo } from "react";
import { ContentDropdown } from "@coverme/elements";
import { FacesheetHousehold } from "./FacesheetHousehold";
import { FacesheetIncome } from "../FacesheetIncome/FacesheetIncome";
import { calculateTotalAllowableIncome, getApplicableHouseholds } from "../../services/magiServices";

export const FacesheetHouseholds = ({ interviewHouseholdMembers, households, interview }) => {
    const applicableHouseholds = useMemo(() => getApplicableHouseholds(households.data), [households]);
    let hasIncome = false;

    if (interview.personInfoScreening != null && interview.personInfoScreening.length > 0) {
        const incomes = interview.personInfoScreening
            .filter(x => x.incomeInfo != null)
            .map(x => x.incomeInfo)
            .filter(x => x.doesReceiveIncome === true && x.incomes != null && x.incomes.length > 0);
        hasIncome = incomes.length > 0;
    }

    return applicableHouseholds.map(household => {
        const totalAllowableIncome = calculateTotalAllowableIncome(household);
        return (
            <>
                {interviewHouseholdMembers.length > 0 && (
                    <ContentDropdown
                        title={`${household.householdType.name} Household`}
                        subtitle={`Countable Members: ${household.countsAs}`}
                        estimatedHeight={1000000}
                    >
                        <div>
                            <FacesheetHousehold
                                interviewHouseholdMembers={interviewHouseholdMembers}
                                magiHousehold={household}
                                screenings={interview.personInfoScreening}
                            />
                        </div>
                    </ContentDropdown>
                )}
                {hasIncome && (
                    <ContentDropdown
                        title={`${household.householdType.name} Income`}
                        estimatedHeight={1000000}
                        subtitle={`Allowable: $${totalAllowableIncome.toFixed(2)}`}
                    >
                        <div>
                            <FacesheetIncome
                                interview={interview}
                                patient={interview.entry.patient}
                                interviewHousehold={interviewHouseholdMembers}
                                magiHousehold={household}
                            />
                        </div>
                    </ContentDropdown>
                )}
            </>
        );
    });
};

export const FacesheetHousehold2 = ({ interviewHouseholdMembers, households, interview }) => {
    const applicableHouseholds = useMemo(() => getApplicableHouseholds(households.data), [households]);
    let hasIncome = false;

    if (interview.personInfoScreening != null && interview.personInfoScreening.length > 0) {
        const incomes = interview.personInfoScreening
            .filter(x => x.incomeInfo != null)
            .map(x => x.incomeInfo)
            .filter(x => x.doesReceiveIncome === true && x.incomes != null && x.incomes.length > 0);
        hasIncome = incomes.length > 0;
    }

    return applicableHouseholds.map(household => {
        const totalAllowableIncome = calculateTotalAllowableIncome(household);
        return (
            <ContentDropdown
                title={`${household.householdType.name} Household`}
                subtitle={`Countable Members: ${household.countsAs}`}
                estimatedHeight={1000000}
            >
                {interviewHouseholdMembers.length > 0 && (
                    <div>
                        <FacesheetHousehold
                            interviewHouseholdMembers={interviewHouseholdMembers}
                            magiHousehold={household}
                            screenings={interview.personInfoScreening}
                        />
                    </div>
                )}
                {hasIncome && (
                    <ContentDropdown
                        title={`${household.householdType.name} Income`}
                        estimatedHeight={1000000}
                        subtitle={`Allowable: $${totalAllowableIncome.toFixed(2)}`}
                        isOpenByDefault={false}
                    >
                        <div>
                            <FacesheetIncome
                                interview={interview}
                                patient={interview.entry.patient}
                                interviewHousehold={interviewHouseholdMembers}
                                magiHousehold={household}
                            />
                        </div>
                    </ContentDropdown>
                )}
            </ContentDropdown>
        );
    });
};
